import VueComment from './VueComment.vue'

const comment = {
    install: function (Vue) {
        Vue.component(VueComment.name, VueComment)
    }
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(comment)
}

export default comment



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-excel-export@0.1.3/~/vue-excel-export/index.js
// module id = VdFE
// module chunks = 5